import script from "./NotificationModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotificationModal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__